// Card swipe 
// Niccos Product Grid
const sliderContainers = document.querySelectorAll(".cust-slider-container");
document.querySelectorAll(".cust-slider-container").forEach((container) => {
  const slider = container.querySelector(".cust-slider");
  const slides = container.querySelectorAll(".cust-slide");
  const prevBtn = container.querySelector(".cust-prev");
  const nextBtn = container.querySelector(".cust-next");
  const progressBar = container.querySelector(".cust-slider-progress-bar");
  let currentSlide = 0;
  let startX = 0;
  let startY = 0;
  let moveX = 0;
  let moveY = 0;
  let isDragging = false;
  let isHorizontalSwipe = false;
  const totalSlides = slides.length;

  function updateSlider(index) {
    currentSlide = index;
    const translateX = -(index * 100);
    slider.style.transform = `translateX(${translateX}%)`;

    slides.forEach((slide, i) => {
      slide.classList.toggle("cust-active", i === index);
    });

    // **Update Progress Bar for Mobile**
    const progressWidth = ((currentSlide + 1) / totalSlides) * 100;
    progressBar.style.width = `${progressWidth}%`;
  }

  // Previous Slide (Desktop Button)
  prevBtn.addEventListener("click", () => {
    currentSlide = currentSlide > 0 ? currentSlide - 1 : totalSlides - 1;
    updateSlider(currentSlide);
  });

  // Next Slide (Desktop Button)
  nextBtn.addEventListener("click", () => {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateSlider(currentSlide);
  });

  // Touch Start (Mobile)
  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
    isHorizontalSwipe = false;
  });

  // Touch Move (Allow Vertical Scroll but Prevent Horizontal Page Movement)
  slider.addEventListener("touchmove", (e) => {
    if (!isDragging) return;

    moveX = e.touches[0].clientX - startX;
    moveY = e.touches[0].clientY - startY;

    if (!isHorizontalSwipe) {
      isHorizontalSwipe = Math.abs(moveX) > Math.abs(moveY);
    }

    if (isHorizontalSwipe) {
      e.preventDefault(); // Prevent page from scrolling when swiping
      slider.style.transform = `translateX(${moveX}px)`;
    }
  }, { passive: false });

  // Touch End (Mobile Swipe Detection)
  slider.addEventListener("touchend", () => {
    isDragging = false;

    if (isHorizontalSwipe) {
      if (moveX > 50) {
        // Swipe Right (Previous Slide)
        currentSlide = currentSlide > 0 ? currentSlide - 1 : totalSlides - 1;
      } else if (moveX < -50) {
        // Swipe Left (Next Slide)
        currentSlide = (currentSlide + 1) % totalSlides;
      }
      updateSlider(currentSlide);
    }
  });

  // **Initialize Progress Bar**
  updateSlider(0);
});